export default "__VITE_ASSET__C9tc$6rD__"